import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import arrowDefault from "../../img/home/market-arrow-default.svg";
import arrowHover from "../../img/home/market-arrow-hover.svg";
import photoForex from "../../img/home/market-forex.webp";
import photoCommodities from "../../img/home/market-commodities.webp";
import photoStocks from "../../img/home/market-stocks.webp";
import photoCrypto from "../../img/home/market-crypto.webp";

const ROW_HEIGHT = 92;

const MARKETS = [
  {
    num: "01",
    t: "home.markets.forex.title",
    c: "home.markets.forex.count",
    photo: photoForex,
    imageTop: -42,
    rotate: "-12deg",
  },
  {
    num: "02",
    t: "home.markets.commodities.title",
    c: "home.markets.commodities.count",
    photo: photoCommodities,
    imageTop: 36,
    rotate: "4deg",
  },
  {
    num: "03",
    t: "home.markets.stocks.title",
    c: "home.markets.stocks.count",
    photo: photoStocks,
    imageTop: 126,
    rotate: "7deg",
  },
  {
    num: "04",
    t: "home.markets.crypto.title",
    c: "home.markets.crypto.count",
    photo: photoCrypto,
    imageTop: 218,
    rotate: "-6deg",
  },
];

function TradeAssets() {
  const { t } = useTranslation();
  const [active, setActive] = useState(null);
  const activeMarket = active === null ? null : MARKETS[active];

  return (
    <section className="mt">
      <div className="glcontainer mb-[40px] xl:mb-[36px]">
        <div className="flex flex-col xl:flex-row xl:gap-[144px] gap-[20px] xl:items-start">
          <h2 className="font-46-28 xl:max-w-[504px]">{t("home.markets.title")}</h2>
          <p className="font-18-14 xl:max-w-[572px]">{t("home.markets.desc")}</p>
        </div>
      </div>

      <div
        className="relative w-full bg-[#f7f7f7] mt-[60px]"
        onMouseLeave={() => setActive(null)}
      >
        <div
          className={`pointer-events-none absolute inset-x-0 bg-[#020202] transition-all duration-300 ease-out ${
            active === null ? "opacity-0" : "opacity-100"
          }`}
          style={{
            height: `${ROW_HEIGHT}px`,
            transform: `translateY(${(active ?? 0) * ROW_HEIGHT}px)`,
          }}
        />

        {activeMarket && (
          <div
            className="pointer-events-none absolute left-1/2 z-[3] hidden h-[170px] w-[170px] -translate-x-1/2 overflow-hidden rounded-[12px] shadow-[0_18px_60px_rgba(0,0,0,0.35)] transition-all duration-300 ease-out md:block xl:h-[250px] xl:w-[250px]"
            style={{
              top: `${activeMarket.imageTop}px`,
              transform: `translateX(-50%) rotate(${activeMarket.rotate})`,
            }}
          >
            <img
              src={activeMarket.photo}
              alt=""
              aria-hidden
              className="h-full w-full object-cover"
            />
          </div>
        )}

        <div className="relative z-[2]">
          {MARKETS.map((item, i) => {
            const isActive = active === i;

            return (
              <button
                key={item.num}
                type="button"
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                className="w-full border-b border-[rgba(0,0,0,0.08)] text-left transition-colors duration-300 cursor-my"
              >
                <div
                  className="glcontainer grid grid-cols-[44px_1fr_auto] items-center gap-[28px] xl:grid-cols-[72px_1fr_auto]"
                  style={{ height: `${ROW_HEIGHT}px` }}
                >
                  <span
                    className={`font-['Montserrat'] text-[32px] font-normal leading-none transition-colors duration-300 ${
                      isActive ? "text-[rgba(255,255,255,1)]" : "text-[#707070]"
                    }`}
                  >
                    {item.num}
                  </span>

                  <div className="flex flex-col gap-[4px]">
                    <span
                      className={`font-['Montserrat'] text-[24px] font-extrabold leading-[1.05] transition-colors duration-300 sm:text-[30px] xl:text-[34px] ${
                        isActive ? "text-white" : "text-[#020202]"
                      }`}
                    >
                      {t(item.t)}
                    </span>
                    <span
                      className={`font-['Inter'] text-[12px] font-normal leading-[1.2] transition-colors duration-300 sm:text-[13px] ${
                        isActive ? "text-[rgba(255,255,255,0.65)]" : "text-[#717171]"
                      }`}
                    >
                      {t(item.c)}
                    </span>
                  </div>

                  <img
                    src={isActive ? arrowHover : arrowDefault}
                    alt=""
                    className="h-[30px] xl:h-[56px] w-[30px] xl:w-[56px] shrink-0 object-contain transition-transform duration-300"
                  />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default TradeAssets;
